import styled, { css } from 'styled-components';

import { BODY } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';

import { SPACING_2, SPACING_8 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

const GET_BORDER_COLOR = props =>
  props.disabled ? props.theme.disabled.border
    : props.error ? props.theme.error.border
      : props.hovered ? props.theme.hover.border
        : props.focused ? props.theme.focused.border
          : props.theme.border;

const GET_OUTLINED_FOCUSED_STYLE = props => `inset 0px 0px 0px ${SPACING_2} ${GET_BORDER_COLOR(props)}`;
const GET_DISABLED_OUTLINED_FOCUSED_STYLE = props => `inset 0px 0px 0px 0.0625rem ${GET_BORDER_COLOR(props)}`;
const GET_UNDERLINED_FOCUSED_STYLE = props => `inset 0px -${SPACING_2} 0px 0px ${GET_BORDER_COLOR(props)}`;
const GET_FOCUSED_BORDER_STYLE = props => props.variant === 'outlined'
  ? GET_OUTLINED_FOCUSED_STYLE(props)
  : GET_UNDERLINED_FOCUSED_STYLE(props);

const GET_OUTLINED_HOVER_STYLE = props => `inset 0px 0px 0px ${SPACING_2} ${GET_BORDER_COLOR(props)}`;
const GET_UNDERLINED_HOVER_STYLE = props => `inset 0px -${SPACING_2} 0px 0px ${GET_BORDER_COLOR(props)}`;
const GET_HOVER_BORDER_STYLE = props => props.variant === 'outlined'
  ? GET_OUTLINED_HOVER_STYLE(props)
  : GET_UNDERLINED_HOVER_STYLE(props);

export default {
  Field: styled.input`
    &::selection {
      background: ${props => props.theme.textSelection}
    }
    color: ${props => props.theme.content};
    ${props => css`
      box-shadow: ${props.readOnly
    ? 'none'
    : props.variant === 'outlined'
      ? `inset 0px 0px 0px 0.0625rem ${GET_BORDER_COLOR(props)}`
      : `inset 0px -0.0625rem 0px 0px ${GET_BORDER_COLOR(props)}`};
      padding: ${props.variant === 'outlined' ? `${SPACING_8} 0.625rem` : `${SPACING_8} 0`};
      flex: ${props.size ? 'none' : '1'};
    `}
    ${BODY};
    line-height: 1.125rem;
    border: none;
    ${props => props.variant === 'underlined' && !props.readOnly && `border-bottom: 0.0625rem solid ${GET_BORDER_COLOR(props)}; box-shadow: none;`}
    background: ${props => props.theme.background};
    &:focus {
      outline: none;
      ${props => props.variant === 'underlined' && !props.readOnly && 'border-bottom: 0.0625rem solid transparent;'}
      ${props => css`box-shadow: ${props.readOnly ? 'none' : GET_FOCUSED_BORDER_STYLE({ ...props, focused: true })};`}
    }
    &:hover {
      &::placeholder {
        color: ${props => props.theme.hover.placeholder}
      }
      ${props => props.variant === 'underlined' && !props.readOnly && 'border-bottom: 0.0625rem solid transparent;'}
      ${({ disabled }) => !disabled &&
      css`
      ${props => css`box-shadow: ${props.readOnly ? 'none' : GET_HOVER_BORDER_STYLE({ ...props, hovered: true })};`}
        outline: none;
      `};
      ${({ readOnly }) => readOnly && css`
        cursor: default;
      `};
    }
    &:hover:focus {
      ${props => css`box-shadow: ${props.readOnly ? 'none' : GET_FOCUSED_BORDER_STYLE({ ...props, focused: true })};`}
      outline: none;
    }
    &:disabled {
      background: ${props => props.theme.disabled.background};
      color: ${props => props.theme.disabled.content};
      ${props => props.variant === 'outlined' && css`box-shadow: ${props.readOnly ? 'none' : GET_FOCUSED_BORDER_STYLE({ ...props, disabled: true })};`}
      ${props => props.variant === 'outlined' && props.disabled && css`box-shadow: ${GET_DISABLED_OUTLINED_FOCUSED_STYLE({ ...props, disabled: true })};`}
      ${props => props.variant === 'underlined' && css`box-shadow: none; border-bottom: ${props.readOnly ? 'none' : `0.0625rem dotted ${GET_BORDER_COLOR(props)}`};`}
      &::placeholder {
        color: ${props => props.theme.disabled.placeholder}
      }
    }
    &::placeholder {
      color: ${props => props.theme.placeholder}
    }
    ${({ readOnly }) => readOnly && css`
      background: ${props => props.theme.readOnly.background};
    `}
  }
  `
};
